// extracted by mini-css-extract-plugin
module.exports = {"form":"SignUpForm_form__1qkzY","row":"SignUpForm_row__2o4G5","divider":"SignUpForm_divider__1caaV"};